import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    SliderScaleLabelWidthsConstantType,
    SliderScaleLabelConstantType,
    SliderScaleDynamicStyleType,
    SliderScaleTickConstantType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const getSliderScaleTickStyle = ({
    currentMeasures,
    currentColors,
    radiuses,
    borders,
    usable,
    tick
}: SliderScaleTickConstantType): ViewStyle => {
    return {
        backgroundColor: tick.isActive ? currentColors.activeTickColor : currentColors.tickColor,
        start: usable * tick.fraction + (currentMeasures.thumbSize - borders.indicator) / 2,
        borderRadius: radiuses.full,
        height: borders.indicator,
        width: borders.indicator
    };
};

export const getSliderScaleLabelWidths = ({
    labels,
    usable
}: SliderScaleLabelWidthsConstantType): Array<number> => {
    return labels.map((label, index) => {
        const previous = (label.fraction - (labels[index - 1]?.fraction ?? label.fraction - 1)) * usable;

        const next = ((labels[index + 1]?.fraction ?? label.fraction + 1) - label.fraction) * usable;

        return Math.min(previous, next);
    });
};

export const getSliderScaleLabelStyle = ({
    currentMeasures,
    usable,
    label,
    width
}: SliderScaleLabelConstantType): ViewStyle => {
    if(label.align === "start") {
        return {
            start: 0
        };
    }

    if(label.align === "end") {
        return {
            end: 0
        };
    }

    return {
        start: usable * label.fraction + (currentMeasures.thumbSize - width) / 2,
        width
    };
};

const stylesheet = StyleSheet.create({
    tick: {
        position: "absolute",
        top: 0
    },
    label: {
        position: "absolute",
        top: 0
    },
    container: {
        pointerEvents: "none"
    },
    ticks: {
        position: "relative"
    },
    labels: {
        position: "relative"
    },
    centerLabel: {
        textAlign: "center"
    },
    labelText: {
        fontVariant: [
            "tabular-nums"
        ]
    },
    edgeLabel: {
        maxWidth: "50%"
    }
});

export const useStyles = ({
    currentMeasures,
    typography,
    borders,
    spaces
}: SliderScaleDynamicStyleType) => {
    const styles = {
        container: {
            marginTop: (currentMeasures.thumbSize - currentMeasures.row) / 2 + spaces.spacingXs,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        labels: {
            height: typography.bodySmallSize.lineHeight
        } as Mutable<ViewStyle>,
        ticks: {
            height: borders.indicator
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
